<div *ngIf="dataIsLoaded">
  <ng-container *ngFor="let item of data;index as i;">
    <span class="menu-item" *ngIf="hasInnerText(item.name)">
      <a [href]="item.url" (click)="handleLink($event, item.url, item.target)" attr.data-automation="{{urlPathId(item.url)}}" target="{{item.target}}" [ngClass]="{'active-link': isActiveLink(item)}" id="dropdownMenu{{i}}" class="navLink" [innerHTML]="item.name | uppercase"></a>
    </span>
  </ng-container>
</div>
